import { Box, Divider, Grid, Typography } from "@mui/material";

import Card from "components/Card";
import CopyToClipboard from "components/CopyToClipboard";

function BoxReferral({ referral }) {
  return (
    <Grid item xs={12}>
      <Card p={0} marginBottom={3}>
        <Box p={3}>
          <Typography variant="h5" color="text.secondary" pb={1}>
            کد دعوت
          </Typography>

          <Typography
            variant="h5"
            color="secondary.main"
            display="flex"
            alignItems="center"
          >
            <Typography component="span" pl={1}>
              {referral?.referralCode}
            </Typography>

            <CopyToClipboard value={referral?.referralCode} />
          </Typography>
        </Box>

        <Divider />

        <Box p={3}>
          <Typography variant="h5" color="text.secondary" pb={1}>
            سهم شما /سهم دوستان
          </Typography>

          <Typography variant="h5" color="secondary.main">
            {referral?.referralPercentChild} %
            <Typography component="span" color="secondary.main" px={1}>
              /
            </Typography>
            {referral?.referralPercentParent} %
          </Typography>
        </Box>
      </Card>
    </Grid>
  );
}

export default BoxReferral;
